import { render, staticRenderFns } from "./KidsGroupExcelTable.vue?vue&type=template&id=0523637c&scoped=true"
import script from "./KidsGroupExcelTable.vue?vue&type=script&lang=js"
export * from "./KidsGroupExcelTable.vue?vue&type=script&lang=js"
import style0 from "./KidsGroupExcelTable.vue?vue&type=style&index=0&id=0523637c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0523637c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0523637c')) {
      api.createRecord('0523637c', component.options)
    } else {
      api.reload('0523637c', component.options)
    }
    module.hot.accept("./KidsGroupExcelTable.vue?vue&type=template&id=0523637c&scoped=true", function () {
      api.rerender('0523637c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/ByGroup/KidsGroupExcelTable.vue"
export default component.exports